<template>
  <el-container id="app" v-hotkey="keymap" >
    <NavigationMenu v-if="isLoggedIn"/>
    <el-main class="main-view">
      <transition name="fade" mode="out-in">
        <router-view v-loading="isLoading"></router-view>
      </transition>
    </el-main>
    <el-dialog :visible.sync="timeEntryDialogOptions.show" class="time-entry-dialog" width="90%" top="20px" :title="timeEntryDialogOptions.title" :close-on-click-modal="false" v-draggable>
      <TimeEntryDialog v-if="timeEntryDialogOptions.show" :options="timeEntryDialogOptions" @close="closeTimeEntryDialog"></TimeEntryDialog>
    </el-dialog>
    <el-dialog :visible.sync="entryAuditDialogOptions.show" class="entry-audit-dialog" width="500px" top="50px" :title="entryAuditDialogOptions.title" :close-on-click-modal="false" v-draggable>
      <EntryAuditDialog v-if="entryAuditDialogOptions.show" :options="entryAuditDialogOptions" @close="closeEntryAuditDialog"></EntryAuditDialog>
    </el-dialog>
  </el-container>
</template>

<script>

import NavigationMenu from '@/components/NavigationMenu'
import TimeEntryDialog from '@/components/TimeEntryDialog'
import EntryAuditDialog from '@/components/EntryAuditDialog'
import { EventHub } from '@/components/EventHub'
import { lazyLoadAll, getCurrentEntry, getTimeRemaining } from '@/utils/store'
import axios from 'axios'

export default {
  name: 'flux-frontend',
  components: {
    NavigationMenu,
    TimeEntryDialog,
    EntryAuditDialog
  },
  data: function () {
    return {
      timeEntryDialogOptions: {
        show: false,
        shown: false
      },
      entryAuditDialogOptions: {
        show: false,
        shown: false
      }
    }
  },
  computed: {
    isLoading: {
      get () {
        return this.$store.getters.appIsLoading
      },
      set (state) {
        this.$store.commit('setAppIsLoading', state)
      }
    },
    user () {
      return this.$store.state.authentication.user
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    keymap () {
      return {
        // bind to hotkey
        'F5': (e) => { this.handleF5(e) },
        'F6': (e) => { this.handleF6(e) },
        'F7': (e) => { this.handleF5(e) }

      }
    }
  },
  watch: {
    isLoggedIn () {
      this.isLoggedIn && this.initializeStore()
    }
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    handleF6 (e) {
      axios.get('https://aed.pro/fluxhook?token=monkey_wrench',
        { crossdomain: true,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        }).then(response => {
      }).catch(error => { console.warn(error) })
      this.$message({
        showClose: true,
        message: 'A back end sync request has been sent.',
        type: 'success'
      })
    },
    handleF5 (e) {
      this.$store.commit('setAppIsLoading', true)
      this.isLoading = true
      let promises = []
      promises.push(this.$store.dispatch('time-entries/loadAll', this.$store.getters.timeEntryFilters))
      promises.push(this.$store.dispatch('tasks/loadAll'))
      promises.push(this.$store.dispatch('events/loadAll'))
      promises.push(this.$store.dispatch('milestones/loadAll'))
      promises.push(this.$store.dispatch('teams/loadAll'))
      promises.push(this.$store.dispatch('clients/loadAll'))
      promises.push(this.$store.dispatch('projects/loadAll'))
      promises.push(this.$store.dispatch('activities/loadAll'))
      promises.push(this.$store.dispatch('roles/loadAll'))
      promises.push(this.$store.dispatch('flux-roles/loadAll'))

      Promise.all(promises).then(() => {
        this.$store.commit('setAppIsLoading', false)
        this.$message({
          showClose: true,
          message: 'All data reloaded',
          type: 'success'
        })
      })
    },
    showTimeEntryDialog ({ title = null, entries = [{}], taskIsDisabled = false, cancel = null, save = null, focus = null }) {
      let dialog = this.timeEntryDialogOptions

      dialog.timeEntries = entries
      dialog.title = title
      dialog.taskIsDisabled = taskIsDisabled
      dialog.cancel = cancel
      dialog.save = save
      dialog.focus = focus
      dialog.show = true
    },
    showEntryAuditDialog ({errors, warnings, onApprove}) {
      let dialog = this.entryAuditDialogOptions
      dialog.errors = errors
      dialog.warnings = warnings
      dialog.title = 'Time Entry Audit'
      dialog.approve = onApprove
      dialog.show = true
    },
    closeTimeEntryDialog () {
      this.timeEntryDialogOptions.show = false
    },
    closeEntryAuditDialog () {
      this.entryAuditDialogOptions.show = false
    },
    initializeStore () {
      lazyLoadAll()
      this.$store.dispatch('users/loadAll').then(() => {
        let promises = []
        promises.push(this.$store.dispatch('time-entries/loadAll', this.$store.getters.timeEntryFilters))
        promises.push(this.$store.dispatch('tasks/loadAll'))
        promises.push(this.$store.dispatch('events/loadAll'))
        promises.push(this.$store.dispatch('milestones/loadAll'))
        promises.push(this.$store.dispatch('teams/loadAll'))
        promises.push(this.$store.dispatch('clients/loadAll'))
        promises.push(this.$store.dispatch('projects/loadAll'))
        promises.push(this.$store.dispatch('activities/loadAll'))
        promises.push(this.$store.dispatch('roles/loadAll'))
        promises.push(this.$store.dispatch('flux-roles/loadAll'))

        Promise.all(promises).then(() => {
          let currentEntry = this.$store.getters['time-entries/all'].filter(entry => entry.relationships.user && entry.relationships.user.data.id === this.$store.state.authentication.user.id && !entry.attributes.end)[0]
          if (currentEntry && currentEntry.task) {
            getTimeRemaining(currentEntry.task)
          }
          this.$store.dispatch('updateUser', this.user)
          window.setInterval(() => lazyLoadAll(), 1000 * 60)
          window.setInterval(() => getCurrentEntry(), 1000 * 30)
        })
      })
    }
  },
  mounted () {
    this.$store.commit('setAppIsLoading', false)
    EventHub.$on('show-new-entry-dialog', data => {
      this.showTimeEntryDialog(data)
    })
    EventHub.$on('show-entry-audit-dialog', data => {
      this.showEntryAuditDialog(data)
    })
  },
  beforeDestroy () {
    EventHub.$off('show-new-entry-dialog')
    EventHub.$off('show-entry-audit-dialog')
  },
  created () {
    let self = this
    let message = null

    this.$api.interceptors.response.use(response => {
      if (message) {
        message.close()
        message = null
        this.$message({
          showClose: true,
          duration: 2000,
          message: `Network connection restored`,
          type: 'success'
        })
      }
      return response
    })

    this.$api.interceptors.response.use(undefined, error => {
      return new Promise(function (resolve, reject) {
        if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
          this.$store.dispatch('logout')
        } else {
          if (!message) {
            message = self.$message({
              showClose: true,
              duration: 0,
              message: `Network connectivity error`,
              type: 'error'
            })
          }
        }
        /* else if (!document.querySelector('.el-message-box__wrapper:not([style*="display: none"])')) {
          let status = error.response ? error.response.status : 'Network'
          let detail = error.response ? error.response.data.errors[0].detail : ''
          let message = error.response ? `Request failed with status code ${status}<br/>${detail}` : 'Request failed due to a network error.'
          self.$alert(message, `${status} Error`, {
            confirmButtonText: 'OK',
            dangerouslyUseHTMLString: true,
            type: 'error'
          })
        } */
      })
    })

    this.isLoggedIn && this.initializeStore()
    document.addEventListener('contextmenu', event => event.preventDefault())
  }
}
</script>

<style lang='scss'>
@import './styles/common.scss';
.time-entry-dialog{
  .el-dialog__body{
    padding-top:5px !important;
    padding-bottom: 1px !important;
  }
}

.el-container {
  height: 100%;

  .main-view {
    padding: 0px !important;
    height: 100%;
    max-height:100vh !important;
    margin:0px !important;
    overflow-x:hidden !important;
  }
}
</style>

